export default __webpack_public_path__ + "cce60ec407f621e77fe29f6f92724707.webp";